const riot = require('riot');
import '../components/customers.tag'
riot.tag2('page-customers', '<customers></customers>', '', '', function(opts) {
});
